module.exports = __webpack_public_path__ + "static/media/electron-logo.42ce9c1f.png";